/** Legacy call recording download. The file name is composed by the UI, not returned by the API. */
import axios from '../axiosInstance'
import { LegacyDownloadRecordingError } from './types'

/** Always resolves: the caller checks `response.error` instead of catching. */
export async function downloadRecording(
  fileUrl = '',
  fileName: string,
): Promise<ArrayBuffer | LegacyDownloadRecordingError> {
  return axios({
    method: 'get',
    url: fileUrl,
    responseType: 'arraybuffer',
  })
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/octet-stream' }),
      )
      link.download = `${fileName}.mp4`

      document.body.appendChild(link)

      link.click()
      setTimeout(() => {
        window.URL.revokeObjectURL(link.href)
        link.remove()
      }, 200)
      return response.data
    })
    .catch(() => ({ error: 'Your call recording cannot be downloaded. Please try again.' }))
}
